import React, { useEffect, useState } from "react";
import styles from "./Files.module.scss";
import Dropzone from "react-dropzone";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import ShowDocsModal from "../../../../../components/modals/show-docs-modal/show-docs-modal";
import { getAlertPopUp } from "../../../../../components/helper/helper";
import moment from "moment";
import FileIcon from "../../../../assets/svg/icons/common/file";
import Ellipsis from "../../../../assets/svg/icons/common/Ellipsis";
import DropDown from "../../../../components/DropDown/DropDown";
import Modal from "../../../../components/modal";
import { Uploads, getFiles, DeleteFile } from "../../../../../api";
import toast from "react-hot-toast";
import Spinner from "../../../../components/Loaders/Spinner";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import useCommonStore from "../../../../stores/common";
import config from "../../../../../config";

function Files({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);

  const [docModal, setDocModal] = useState(false);
  const [docModalFile, setDocModalFile] = useState(null);
  const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileTitles, setSelectedFileTitles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const openDocModal = async (element) => {
    if (element.id) {
      const fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];
      const fileNameParts = element.pdf_converted
        ? element.pdf_converted.split(".")
        : element.file.split(".");
      const type =
        fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : "";

      if (fileToShow.includes(type)) {
        setDocModalFile({ type, title: element.file, id: element.id });
        setDocModal(true);
      } else {
        try {
          const response = await getAppFileData(element.id);
          if (response.success) {
            const data = response.data;
            const fileNameParts = data.pdf_converted
              ? data.pdf_converted.split(".")
              : data.file.split(".");
            const fileData = {
              type:
                fileNameParts.length > 1
                  ? fileNameParts[fileNameParts.length - 1]
                  : "",
              title: data.file,
              id: data.id,
            };
            setDocModalFile(fileData);
            setDocModal(true);
          } else {
            getAlertPopUp({
              title: "Error!",
              html: response.message,
              error: true,
            });
          }
        } catch (error) {
          getAlertPopUp({ title: "Error!", html: error.message, error: true });
        }
      }
    } else if (element.name && element.path) {
      const filePath = element.path.replaceAll("/", "*");
      setDocModalFile({ type: "pdf", title: element.name, id: filePath });
      setDocModal(true);
    }
  };

  const drop_down_options = [
    {
      text: "Delete",
      type: "normal",
      onClick: () => handleDelete(file.id),
    },
  ];

  const handleDelete = (file) => {
    setConfirmDelete(true);
    setFileToDelete(file);
  };

  const fetchFiles = () => {
    setIsLoading(true);
    getFiles({
      id: appData.id,
    })
      .then((res) => {
        if (res.status) {
          setUploadedFiles(res.uploads);
        } else {
          toast.error("Error while fetching files");
        }
      })
      .catch((err) => {
        toast.error("Error while fetching files");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const onChangeFileTitle = (index, event) => {
    if (event.target.value == "") {
      toast.error("Please select a valid value");
      return;
    }
    let data = selectedFileTitles;
    data[index] = event.target.value;
    setSelectedFileTitles(data);
  };

  const file_title_options = [
    { label: "Please Select", value: "" },
    { label: "Drivers License", value: "Drivers License" },
    { label: "Voided Check", value: "Voided Check" },
    { label: "Bank Statements", value: "Bank Statements" },
    { label: "Processing Statements", value: "Processing Statements" },
    { label: "Financials", value: "Financials" },
    {
      label: "Misc. Business Information",
      value: "Misc. Business Information",
    },
    { label: "Reserve", value: "Reserve" },
    { label: "Inside Photo", value: "Inside Photo" },
    { label: "Outside Photo", value: "Outside Photo" },
    { label: "Marketing Material", value: "Marketing Material" },
    { label: "Rate Review", value: "Rate Review" },
    { label: "Menu for MaxxPay", value: "Menu for MaxxPay" },
    { label: "WHO pre-questionnaire", value: "WHO pre-questionnaire" },
    { label: "Misc.", value: "Misc." },
  ];

  const submit = () => {
    if (selectedFiles.length !== selectedFileTitles.length) {
      toast.error("Please choose file type for all the files");
      return;
    }

    const toastId = toast.loading("Uploading files...", {
      duration: 30 * 1000,
    });
    setIsOpenUploadModal(false);
    const data = new FormData();
    selectedFiles.forEach((file) => {
      data.append("files[]", file, file.name);
    });
    selectedFileTitles.forEach((element) => {
      data.append("title[]", element);
    });

    Uploads(appData.id, data)
      .then((response) => {
        if (response.status) {
          toast.success("Files uploaded successfully", {
            id: toastId,
            duration: 5 * 1000,
          });
          fetchFiles();
        } else {
          toast.error(response.message, { id: toastId, duration: 10 * 1000 });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          id: toastId,
          duration: 10 * 1000,
        });
      })
      .finally(() => {
        setSelectedFileTitles([]);
        setSelectedFiles([]);
      });
  };

  const onConfirmClick = () => {
    const toastId = toast.loading("Deleting file...", { duration: 30 * 1000 });
    closeConfirmationModal();
    DeleteFile({
      id: fileToDelete.powerapp_id,
      upload_id: fileToDelete.id,
    })
      .then((res) => {
        if (res.success) {
          toast.success("File deleted successfully", {
            id: toastId,
            duration: 5 * 1000,
          });
        } else {
          toast.error(response.message, { id: toastId, duration: 10 * 1000 });
        }
      })
      .catch((err) => {
        toast.error(response.message, { id: toastId, duration: 10 * 1000 });
      })
      .finally(() => {
        fetchFiles();
      });
  };

  const closeConfirmationModal = () => {
    setConfirmDelete(false);
    setFileToDelete(null);
  };

  const downloadFile = () => {
    const downloadUrl = `${config.paymentcloud.STRATUS_URL}download-all-file/${appData.id}`;
    window.open(downloadUrl, "_blank");
  }

  return (
    <div
      className={`${styles.files_tab} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={styles.drag_n_drop_container}>
        <Dropzone
          onDrop={(selectedFiles) => {
            setSelectedFiles(selectedFiles);
            setIsOpenUploadModal(true);
          }}
          minSize={100}
          maxSize={1000000 * 200}
        >
          {({ getRootProps, getInputProps }) => (
            <>
              {expandAppDetails && (
                <h6 className={styles.upload_heading}>Upload Files</h6>
              )}
              <section className={styles.dnd}>
                <div {...getRootProps()} className={styles.dnd_section}>
                  <input {...getInputProps()} />
                  <div className={styles.inner_content}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21 13.5001V19.5001C21 19.699 20.921 19.8898 20.7803 20.0304C20.6397 20.1711 20.4489 20.2501 20.25 20.2501H3.75C3.55109 20.2501 3.36032 20.1711 3.21967 20.0304C3.07902 19.8898 3 19.699 3 19.5001V13.5001C3 13.3012 3.07902 13.1104 3.21967 12.9698C3.36032 12.8291 3.55109 12.7501 3.75 12.7501C3.94891 12.7501 4.13968 12.8291 4.28033 12.9698C4.42098 13.1104 4.5 13.3012 4.5 13.5001V18.7501H19.5V13.5001C19.5 13.3012 19.579 13.1104 19.7197 12.9698C19.8603 12.8291 20.0511 12.7501 20.25 12.7501C20.4489 12.7501 20.6397 12.8291 20.7803 12.9698C20.921 13.1104 21 13.3012 21 13.5001ZM8.78063 7.28073L11.25 4.81041V13.5001C11.25 13.699 11.329 13.8898 11.4697 14.0304C11.6103 14.1711 11.8011 14.2501 12 14.2501C12.1989 14.2501 12.3897 14.1711 12.5303 14.0304C12.671 13.8898 12.75 13.699 12.75 13.5001V4.81041L15.2194 7.28073C15.3601 7.42146 15.551 7.50052 15.75 7.50052C15.949 7.50052 16.1399 7.42146 16.2806 7.28073C16.4214 7.14 16.5004 6.94912 16.5004 6.7501C16.5004 6.55108 16.4214 6.36021 16.2806 6.21948L12.5306 2.46948C12.461 2.39974 12.3783 2.34442 12.2872 2.30668C12.1962 2.26894 12.0986 2.24951 12 2.24951C11.9014 2.24951 11.8038 2.26894 11.7128 2.30668C11.6217 2.34442 11.539 2.39974 11.4694 2.46948L7.71937 6.21948C7.57864 6.36021 7.49958 6.55108 7.49958 6.7501C7.49958 6.94912 7.57864 7.14 7.71937 7.28073C7.86011 7.42146 8.05098 7.50052 8.25 7.50052C8.44902 7.50052 8.63989 7.42146 8.78063 7.28073Z"
                        fill="#3A383F"
                      />
                    </svg>
                    <div>
                      <p>
                        Upload documents by drag and drop or{" "}
                        <span>click to upload</span>
                      </p>
                      <p>pdf, xls, docx</p>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </Dropzone>
      </div>

      <div className={styles.file_lists}>
        {/* Signed files list */}
        <div className={styles.file_list}>
          <div className={styles.head}>
            <h6>Signed files</h6>
            <ButtonIcon 
              textColor={"#254FE2"}
              onClick={() => downloadFile()}            
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M3.14625 7.35375C3.05243 7.25993 2.99972 7.13268 2.99972 7C2.99972 6.86732 3.05243 6.74007 3.14625 6.64625C3.24007 6.55243 3.36732 6.49972 3.5 6.49972C3.63268 6.49972 3.75993 6.55243 3.85375 6.64625L7.5 10.2931V2C7.5 1.86739 7.55268 1.74021 7.64645 1.64645C7.74021 1.55268 7.86739 1.5 8 1.5C8.13261 1.5 8.25979 1.55268 8.35355 1.64645C8.44732 1.74021 8.5 1.86739 8.5 2V10.2931L12.1462 6.64625C12.1927 6.59979 12.2479 6.56294 12.3086 6.5378C12.3692 6.51266 12.4343 6.49972 12.5 6.49972C12.5657 6.49972 12.6308 6.51266 12.6914 6.5378C12.7521 6.56294 12.8073 6.59979 12.8538 6.64625C12.9002 6.6927 12.9371 6.74786 12.9622 6.80855C12.9873 6.86925 13.0003 6.9343 13.0003 7C13.0003 7.0657 12.9873 7.13075 12.9622 7.19145C12.9371 7.25214 12.9002 7.3073 12.8538 7.35375L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L3.14625 7.35375ZM13.5 13H2.5C2.36739 13 2.24021 13.0527 2.14645 13.1464C2.05268 13.2402 2 13.3674 2 13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5C14 13.3674 13.9473 13.2402 13.8536 13.1464C13.7598 13.0527 13.6326 13 13.5 13Z"
                  fill="#254FE2"
                />
              </svg>
              <span>Download all</span>
            </ButtonIcon>
          </div>

          <div className={styles.list}>
            {appData.files.map((file, index) => (
              <div key={index} className={styles.file}>
                <div onClick={() => openDocModal(file)}>
                  <FileIcon />
                  <span>{file.name}</span>
                </div>
                <ButtonIcon bgColor={"transparent"} size="small">
                  <Ellipsis />
                </ButtonIcon>
              </div>
            ))}
          </div>
        </div>

        {/* Uploaded files list */}
        <div className={styles.file_list}>
          <div className={styles.head}>
            <h6>Uploaded files</h6>
            <ButtonIcon
              textColor={"#254FE2"}
              onClick={() => downloadFile()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M3.14625 7.35375C3.05243 7.25993 2.99972 7.13268 2.99972 7C2.99972 6.86732 3.05243 6.74007 3.14625 6.64625C3.24007 6.55243 3.36732 6.49972 3.5 6.49972C3.63268 6.49972 3.75993 6.55243 3.85375 6.64625L7.5 10.2931V2C7.5 1.86739 7.55268 1.74021 7.64645 1.64645C7.74021 1.55268 7.86739 1.5 8 1.5C8.13261 1.5 8.25979 1.55268 8.35355 1.64645C8.44732 1.74021 8.5 1.86739 8.5 2V10.2931L12.1462 6.64625C12.1927 6.59979 12.2479 6.56294 12.3086 6.5378C12.3692 6.51266 12.4343 6.49972 12.5 6.49972C12.5657 6.49972 12.6308 6.51266 12.6914 6.5378C12.7521 6.56294 12.8073 6.59979 12.8538 6.64625C12.9002 6.6927 12.9371 6.74786 12.9622 6.80855C12.9873 6.86925 13.0003 6.9343 13.0003 7C13.0003 7.0657 12.9873 7.13075 12.9622 7.19145C12.9371 7.25214 12.9002 7.3073 12.8538 7.35375L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L3.14625 7.35375ZM13.5 13H2.5C2.36739 13 2.24021 13.0527 2.14645 13.1464C2.05268 13.2402 2 13.3674 2 13.5C2 13.6326 2.05268 13.7598 2.14645 13.8536C2.24021 13.9473 2.36739 14 2.5 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5C14 13.3674 13.9473 13.2402 13.8536 13.1464C13.7598 13.0527 13.6326 13 13.5 13Z"
                  fill="#254FE2"
                />
              </svg>
              <span>Download all</span>
            </ButtonIcon>
          </div>

          {isLoading && (
            <div className={styles.loader}>
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <div className={styles.list}>
              {uploadedFiles.map((file, index) => (
                <div key={index} className={styles.file}>
                  <div onClick={() => openDocModal(file)}>
                    <FileIcon />
                    <span>
                      {file.file} - {file.title} -{" "}
                      {moment(file.created_at).format("MMM D, YYYY | H:mm A")}
                    </span>
                  </div>
                  <DropDown
                    options={[
                      {
                        text: "Delete",
                        type: "normal",
                        onClick: () => handleDelete(file),
                      },
                    ]}
                    size="small"
                  >
                    <Ellipsis />
                  </DropDown>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ShowDocsModal
        isOpen={docModal}
        close={() => setDocModal(false)}
        file={docModalFile}
      />

      <Modal
        isOpen={isOpenUploadModal}
        onClose={() => setIsOpenUploadModal(false)}
        header={""}
      >
        <h5 className={styles.modal_title}>Select Type of File(s)</h5>
        <div className={styles.upload_file_list}>
          {selectedFiles.map((file, index) => (
            <div key={index} className={styles.upload_file_item}>
              <span className={styles.file_name}>{file?.path}</span>
              <div className={styles.select_type}>
                <select
                  className={styles.input_select}
                  onChange={(e) => onChangeFileTitle(index, e)}
                >
                  {file_title_options.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
        </div>
        <footer className={styles.footer}>
          <ButtonIcon
            bgColor={"#FFFFFF"}
            textColor={"#4C70EF"}
            onClick={() => {
              setSelectedFileTitles([]);
              setSelectedFiles([]);
              setIsOpenUploadModal(false);
            }}
          >
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFFFFF"
            onClick={() => submit()}
          >
            Submit
          </ButtonIcon>
        </footer>
      </Modal>

      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          onClose={() => closeConfirmationModal()}
          message={
            "Are you sure you want to delete selected file? You can’t undo this action."
          }
          onConfirmClick={onConfirmClick}
        />
      )}
    </div>
  );
}

export default Files;
